// Free webinars' view model (FreeWebinars.dc.html), from the page's own read of hub.webinars and the
// Library's my_replay_cta answers. Pure: format.js and vimeo.js only.
//
// - Coming up: every shown webinar that hasn't ended, soonest first, with Register on Zoom. It
//   stays until its end time, so someone can still register while it's on (Zoom takes them).
// - Watch again: every shown webinar that has ended with its replay up, newest first. Each replay has
//   its own page (Adam, 23 Oct), replayPath(id), where it plays: every card for 1 opens it.
// - Each card has Adam's own thumbnail where it has 1 (Adam, 9 Oct), else the date panel, and its date
//   in words too, since a thumbnail doesn't say when: "Thu 22 Oct, 7pm to 8:30pm UK time" on 1 coming
//   up, "Wed 16 Sep" on a replay.
// - A replay's call to action (cta) is there only for someone who doesn't own what it sells
//   (my_replay_cta's hidden), and null for anyone who does, whatever their access: nothing takes its
//   place (Adam, 23 Oct: the owner's "You're in <product> already" is gone).
import * as f from '../lib/format.js'
import { parseVimeo } from './vimeo.js'

const MIN = 60e3

// A replay's own page (Adam, 23 Oct), where every card for it points: /free-webinars/replay/<id>
const REPLAY_BASE = '/free-webinars/replay/'
export function replayPath(id) {
  return `${REPLAY_BASE}${encodeURIComponent(id)}`
}

// The replay a path names, or null: '/free-webinars/replay/<id>' gives '<id>'
export function replayIdIn(path) {
  if (!path || !path.startsWith(REPLAY_BASE)) return null
  const rest = path.slice(REPLAY_BASE.length).replace(/\/$/, '')
  if (!rest || rest.includes('/')) return null
  try { return decodeURIComponent(rest) } catch { return null }
}

// 7pm to 8:30pm UK time (the app's own clock format; the board writes 8.30pm)
export function timeLine(startMs, minutes) {
  return `${f.time(startMs)} to ${f.time(startMs + minutes * MIN)} UK time`
}

function chaptersOf(w) {
  return (Array.isArray(w.replay_chapters) ? w.replay_chapters : [])
    .filter(c => Number.isFinite(c?.start_seconds) && c.title)
    .sort((a, b) => a.start_seconds - b.start_seconds)
    .map(c => ({ seconds: c.start_seconds, time: f.clock(c.start_seconds), title: c.title }))
}

// The replay's call to action, from the webinar's own fields, or null for someone who owns what it
// sells (hidden) or when Adam hasn't set 1
function ctaFor(w, cta) {
  if (cta?.hidden || !w.cta_label || !w.cta_url) return null
  return {
    sellsName: cta?.sells_name || null,
    sellsLook: cta?.sells_look || null,
    text: w.cta_text || '',
    label: w.cta_label,
    url: w.cta_url,
  }
}

export function webinarPage({ webinars, progress, lib, nowMs }) {
  const ctas = lib.ctas || {}
  const saved = new Map((progress || []).map(r => [r.webinar_id, r]))
  const shown = (webinars || []).filter(w => w.shown).map(w => {
    const start = Date.parse(w.starts_at)
    return { w, start, end: start + w.duration_minutes * MIN, cta: ctas[w.id] || null }
  })
  const base = ({ w, start, cta }) => ({
    id: w.id,
    title: w.title,
    description: w.description || '',
    block: f.dateBlock(start),
    date: f.shortDate(start),
    thumbnailPath: w.thumbnail_path || null,
    sellsName: cta?.sells_name || null,
    sellsLook: cta?.sells_look || null,
  })
  const upcoming = shown.filter(x => x.end > nowMs).sort((a, b) => a.start - b.start).map(x => ({
    ...base(x),
    time: `${f.shortDate(x.start)}, ${timeLine(x.start, x.w.duration_minutes)}`,
    registrationUrl: x.w.registration_url || null,
  }))
  const replays = shown.filter(x => x.w.replay_up && x.end <= nowMs).sort((a, b) => b.start - a.start).map(x => ({
    ...base(x),
    vimeo: parseVimeo(x.w.replay_url),
    duration: x.w.replay_duration_seconds || null,
    chapters: chaptersOf(x.w),
    savedSeconds: saved.get(x.w.id)?.position_seconds || 0,
    cta: ctaFor(x.w, x.cta),
  }))
  return { upcoming, replays }
}
